import React, { useEffect } from 'react';
import Header from '../../../Public/Header/Header';
import ContentsWrapper from '../../../Public/Wrapper/ContentsWrapper';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { makeStyles } from '@material-ui/core/styles';
import { useRecoilState } from 'recoil';
import IconButton from '@material-ui/core/IconButton';
import CancelIcon from '@material-ui/icons/Cancel';
import { decode as htmlDecode } from 'html-entities';

import { geoBoundaryTabListState, geoBoundaryTabIndexState, IGeoBound } from '../../../../core/store/GeoBoundaryStore';
import GeoBoundaryDetail from './GeoBoundaryDetail';
import GeoBoundaryList from './GeoBoundaryList';



const useStyles = makeStyles(() => ({
  margin: {
    margin: "0 0 0 10px",
  },
}));


const GeoBoundary = () => {

  const [geoBoundaryTabList, setGeoBoundaryTabList] = useRecoilState(geoBoundaryTabListState);
  const [tabIndex, setTabIndex] = useRecoilState(geoBoundaryTabIndexState);

  const classes = useStyles();

  //init Tab list when init
  useEffect(() => {
    setGeoBoundaryTabList([]);
    setTabIndex(0);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {

    if (geoBoundaryTabList.length < tabIndex - 1) {

      setTabIndex(0);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [geoBoundaryTabList, tabIndex]);

  const addTab = (item: IGeoBound) => {

    const thisIndex = geoBoundaryTabList.findIndex((i: IGeoBound) => {
      if (i.GeoBoundaryId === item.GeoBoundaryId)
        return true;

      return false;
    });

    //if (searchTab.length == 0) {
    if (thisIndex < 0) {
      setGeoBoundaryTabList([...geoBoundaryTabList, item]);
    }
    else {

      setTabIndex(thisIndex + 2);
    }
  };

  const removeTab = (removeItem: IGeoBound) => {
    //setTabIndex(0);
    const filtered = geoBoundaryTabList.filter((i: IGeoBound) => {
      return i.GeoBoundaryId !== removeItem.GeoBoundaryId;
    });

    setGeoBoundaryTabList(filtered);
  };



  return (
    <ContentsWrapper header={<Header title="Geo Boundary" />}>
      <div className="row no-gutters">
        <div className="col-md-12  mt-3">
          <div className="tab-content" id="myTabContent">
            <Tabs forceRenderTabPanel selectedIndex={tabIndex} onSelect={index => setTabIndex(index)}>
              <TabList>
                <Tab height="38" >Geo Boundary</Tab>
                <Tab height="38" >Add </Tab>
                {
                  geoBoundaryTabList?.map((item) =>
                    <Tab key={item.GeoBoundaryId} height="38">
                      {htmlDecode(item.GeoBoundaryName)}
                      <IconButton aria-label="delete" className={classes.margin} size="small" onClick={() => removeTab(item)}>
                        <CancelIcon fontSize="inherit" />
                      </IconButton>
                    </Tab>
                  )
                }
              </TabList>
              <TabPanel>
                <GeoBoundaryList addTab={addTab} />
              </TabPanel>
              <TabPanel>
                <GeoBoundaryDetail item={undefined} />
              </TabPanel>
              {
                geoBoundaryTabList?.map((item: IGeoBound) => (
                  <TabPanel key={item.GeoBoundaryId} headers={htmlDecode(item.GeoBoundaryName)}>
                    <GeoBoundaryDetail
                      item={item}
                    />
                  </TabPanel>
                ))
              }
            </Tabs>
          </div>
        </div>
      </div>
    </ContentsWrapper>
  );
};

export default GeoBoundary;
